import * as React from "react";
import { useTypedSelector } from "../../state/store";
import { SpaciousTypography } from "../styleComponents";
import MarkdownText from "../MarkdownText";

var PeerReviewsGuidance = function PeerReviewsGuidance(_a) {
  var givenLabel = _a.givenLabel,
      guidanceText = _a.guidanceText,
      peerReviewsCompletedInfo = _a.peerReviewsCompletedInfo;
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var given = userQuizState ? userQuizState.peerReviewsGiven : 0;
  var required = quiz && quiz.course.minPeerReviewsGiven || 0;
  return React.createElement("div", null, React.createElement(MarkdownText, {
    variant: "subtitle1"
  }, guidanceText), React.createElement(SpaciousTypography, {
    variant: "subtitle1"
  }, givenLabel, ": ", given, "/", required));
};

export default PeerReviewsGuidance;